export const getHubList = async (sendAndWaitWs) => {
  const response = await sendAndWaitWs("/hub/list", JSON.stringify({}));
  if (response.error) {
    return response.error;
  }
  const data = JSON.parse(response.payload);
  // Response is ListResponseData with hubs array
  return data.hubs || [];
};

export const removeHub = async (sendAndWaitWs, hubId, force = false) => {
  const request = {
    hubId,
    force,
  };
  const response = await sendAndWaitWs("/hub/revoke", JSON.stringify(request));
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const restartHub = async (sendAndWaitWs, hubId) => {
  const request = {
    hubId,
  };
  const response = await sendAndWaitWs("/hub/restart", JSON.stringify(request));
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const clearHubCache = async (sendAndWaitWs, hubId) => {
  const request = {
    hubId,
  };
  const response = await sendAndWaitWs(
    "/hub/clearCache",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getSetupStatus = async (sendAndWaitWs) => {
  const response = await sendAndWaitWs(
    "/hub/setup/getStatus",
    JSON.stringify({})
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const cancelSetup = async (sendAndWaitWs) => {
  const response = await sendAndWaitWs("/hub/setup/cancel", JSON.stringify({}));
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const diagnoseHub = async (sendAndWaitWs, hubId) => {
  const request = {
    hubId,
  };
  const response = await sendAndWaitWs(
    "/hub/diagnose",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};
